import { createErrorPage } from '../errorPages'
import { getAppNames, registerApplication, unregisterApplication } from 'single-spa'

const showErrorPage = async (errorPageName, targetGetter, pageProps) => {
  if (getAppNames().includes('errorPage')) {
    console.log('Unregistering error page')
    try {
      await unregisterApplication('errorPage')
    } catch (e) {
      console.warn(e)
    }
  }

  const errorPage = await createErrorPage(errorPageName, targetGetter, pageProps)
  registerApplication({
    name: 'errorPage',
    app: errorPage,
    activeWhen: () => true
  })
}

// this is a destructive action and the user has no other option than reloading the page
export const showTotalErrorPage = async (errorPageName, pageProps) => {
  window.onResourcesLoaded()
  const targetGetter = () => document.body
  for (const appName of getAppNames()) {
    try {
      await unregisterApplication(appName)
    } catch (e) { }
  }

  window.removeAppContainer()

  await showErrorPage(errorPageName, targetGetter, pageProps)
}

export const showContextErrorPage = async (appOrParcelName, errorPageName, pageProps) => {
  const targetGetter = () => document.getElementById(`single-spa-application:${appOrParcelName}`)
  await showErrorPage(errorPageName, targetGetter, pageProps)
}

export const handleSingleSpaError = async (err) => {
  // ignore errors that are caused by error pages :D
  if (err.appOrParcelName === 'errorPage') {
    return
  }
  showTotalErrorPage('genericTotal')
  /* if (err.appOrParcelName === 'mfe_nav') {
  } else {
    showContextErrorPage(err.appOrParcelName, 'contextLoading', { appName: err.appOrParcelName })
  } */
}

export const handleAuthError = () => {
  const localStorageKey = 'portal.autoRecoverUnauthorized'
  if (window.localStorage.getItem(localStorageKey) === 'true') {
    showTotalErrorPage('genericTotal', { text: 'Aufgrund von zu langer Inaktivität müssen Sie sich erneut anmelden', action: '__publicPath__/oauth/logout', actionText: 'Logout', actionFallback: false })
    window.localStorage.removeItem(localStorageKey)
  } else {
    window.localStorage.setItem(localStorageKey, 'true')
    console.warn('trying to auto handle auth error by revoking the session')
    window.location.href = '__publicPath__/session/revoke'
  }
}
